module.exports = __webpack_public_path__ + "img/reload.0a26d97d.svg";